import { Injectable, inject } from '@angular/core';

import { EventParticipant } from '@frontend/sports/betting-offer/feature/model';
import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

export interface OptionGroupTrackingEventsData {
    label: string;
    actionEvent: string;
    participants: EventParticipant[];
    locationEvent: string;
    eventDetailText: string;
    event: string;
    sportId?: number;
    leagueId?: number;
    marketId?: string;
    eventId?: string;
    categoryType?: string;
    positionEvent?: string;
}

@Injectable({ providedIn: 'root' })
export class OptionGroupTrackingService {
    private trackingService = inject(TrackingService);

    trackCollapseExpandClick(
        label: string,
        expandCollapse: string,
        participants: EventParticipant[],
        locationEvent: string,
        eventDetailText: string,
    ): void {
        this.trackEvents({
            label,
            actionEvent: expandCollapse,
            participants,
            locationEvent,
            eventDetailText,
            event: trackingConstants.EVENT_TRACKING,
        });
    }

    trackEvents(eventsData: OptionGroupTrackingEventsData): void {
        const {
            label,
            actionEvent,
            participants,
            locationEvent,
            eventDetailText,
            sportId,
            leagueId,
            event,
            marketId,
            eventId,
            categoryType,
            positionEvent,
        } = eventsData;
        const trackingData = {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: categoryType ?? trackingConstants.SPORTS_EVENT,
            [trackingConstants.COMPONENT_LABEL_EVENT]: label,
            [trackingConstants.COMPONENT_ACTION_EVENT]: actionEvent,
            [trackingConstants.COMPONENT_POSITION_EVENT]:
                positionEvent ?? (participants.length >= 2 ? participants[0].name + ' vs ' + participants[1].name : ''),
            [trackingConstants.COMPONENT_LOCATION_EVENT]: locationEvent,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: eventDetailText,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
            [trackingConstants.SPORT_ID]: sportId,
            [trackingConstants.SPORT_LEAGUE_ID]: leagueId?.toString(),
            [trackingConstants.MARKET_ID]: marketId?.toString(),
            [trackingConstants.SPORT_EVENT_ID]: eventId,
        };

        this.trackingService.track(event, trackingData);
    }
}
